import {PageManager} from 'genesis-packages/core';
import './MULTI_SYSTEMS.scss';
import PDFViewer from 'extensions/PDFViewer/PDFViewer';

export default class MULTI_SYSTEMS extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	onReady () {

		new PDFViewer(this.pageContext.PDF_Viewer_Url, true);

	}

};
